import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Kpimaster } from '../models/commission/kpimaster.model';
import { HttpClient } from '@angular/common/http';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { HomeModel } from '../models/home/home.model';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class HomeService {

    private host = environment.apiUrl + "home";
    public loggedinUser: string = '';
    opts = [];

    constructor(private http: HttpClient, private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
        if (this.loggedinUser == "" || this.loggedinUser == null) {
            this.loggedinUser = "NA"
        } else {
            this.loggedinUser = this.authGaurdService.loginUser();
        }
    }

    public getDisputeStatus(commPlanId: number, calRunId: number): Observable<HomeModel[]> {
        return this.http.get<HomeModel[]>(`${this.host}/getdisputestatus/` + commPlanId + '/' + calRunId);
    }

    public getCommplansList(empid: string, role: string): Observable<HomeModel[]> {
        return this.http.get<HomeModel[]>(`${this.host}/getcommplanslist/` + empid + '/' + role);
    }

    public getHomeCommplansList(empid: string, role: string): Observable<HomeModel[]> {
        return this.http.get<HomeModel[]>(`${this.host}/gethomecommplanslist/` + empid + '/' + role);
    }

    public getCalrunidsList(scempid: number): Observable<HomeModel[]> {
        return this.http.get<HomeModel[]>(`${this.host}/getcalrunidslist/` + scempid);
    }

    public getCommRevList(calyear: string, scempid: number, comm_plan_id: number): Observable<HomeModel[]> {
        // console.log(this.http.get<HomeModel[]>(`${this.host}/getcommrevlist/`+calyear+'/'+scempid));
        return this.http.get<HomeModel[]>(`${this.host}/getcommrevlist/` + calyear + '/' + scempid + '/' + comm_plan_id );
    }

    // public loadChartDefault(commyear: number,scempid: string): Observable<HomeModel[]> {
    //     return this.http.get<HomeModel[]>(`${this.host}/loadchartdefault/`+commyear+'/'+scempid);
    // }

    public loadChart(commyear: number, scempid: string): Observable<HomeModel[]> {
        return this.http.get<HomeModel[]>(`${this.host}/loadchart/` + commyear + '/' + scempid);
    }

    loadChart1() {
        this.opts = [];
        let url = this.host + '/loadchart';
        return this.opts.length ?
            of(this.opts) :
            this.http.get<any>(url).pipe(tap(data => this.opts = data))
    }

}
